
// プラグインの呼び出し
import "./libs/slick.min.js"



// モジュールの呼び出し
import smoothScroll from "./module/smoothScroll";
import deviceJudge from "./module/deviceJudge";
import externalLink from "./module/externalLink";
import headerFixed from "./module/headerFixed";
import displayMenu from "./module/displayMenu";
import pageTop from "./module/pageTop";
import topAnime from "./module/topAnime";
import messageInfo from "./module/messageInfo";
import tagFiltering from "./module/tagFiltering";
import animeTrigger from "./module/animeTrigger";
import textClamp from "./module/textClamp";
import resizeClamp from "./module/resizeClamp";
import newsTagDefault from "./module/newsTagDefault";
import projectFlag from "./module/projectFlag";
import searchBox from "./module/search";
import slider from "./module/slider";


$(document).ready(function () {
  externalLink();                           //外部からの内部ページリンク
});



// モジュールの実行
$(window).on('load',function(){
  // 全てのページで実行
  smoothScroll();                           //ページ内リンク
  deviceJudge();                            //device判定
  headerFixed();                            //固定headerの表示
  pageTop();
  displayMenu();                            //headerメニュー表示
  textClamp();                               //３点リーダー表示
  animeTrigger();                            //アニメーション用クラス付与
  searchBox();

  //cssアニメーションバグ回避用
  $("body").removeClass("preload");
  // 特定ページでのみ実行
  if($('main#top').length) {
    // topのみで実行
    // topAnime();
    messageInfo();
    slider();
  } else if ($('main#message').length || $('main#about').length) {
    messageInfo();
  } else if ($('main#article_list').length) {
    tagFiltering();                           //タグ選択による記事絞り込み
  } else if ($('main#news_list').length) {
    newsTagDefault()                          //初回のnewsタグ
    tagFiltering();
  }

  // PICKUPプロジェクトが存在する時
  if ($('.js-pickupProject').length) {
    projectFlag();
  }

});

var resizeTimer = null;
$(window).on('resize',function(){
  resizeClamp(resizeTimer);
  headerFixed();
});





// WEBPACK FOOTER //
// ./js/main.js